module.exports = __webpack_public_path__ + "img/levelup-icon-delivery-note.9e3767da.svg";